__turbopack_context__.v({
  "banner_btn": "Topbanner-module-scss-module__ghTdCW__banner_btn",
  "banner_text": "Topbanner-module-scss-module__ghTdCW__banner_text",
  "banner_text_con": "Topbanner-module-scss-module__ghTdCW__banner_text_con",
  "down": "Topbanner-module-scss-module__ghTdCW__down",
  "home_banner": "Topbanner-module-scss-module__ghTdCW__home_banner",
  "top_banner": "Topbanner-module-scss-module__ghTdCW__top_banner",
  "without_image_banner": "Topbanner-module-scss-module__ghTdCW__without_image_banner",
});
